import { render, staticRenderFns } from "./ReportedReviews.vue?vue&type=template&id=6a60eff2&"
import script from "./ReportedReviews.vue?vue&type=script&lang=js&"
export * from "./ReportedReviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports